<template>
  <div class="swiper-banner">
    <Swiper
      refs="campaignSwiper"
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      :slides-per-group="1"
      :loop="true"
      :loop-fill-group-with-blank="true"
      :pagination="{ enabled: true, clickable: true }"
      :navigation="{
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }"
      :breakpoints="{
        '769': {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
      }"
    >
      <SwiperSlide v-for="(banner, index) of bannerList" :key="index">
        <div class="row">
          <div class="col-12 col-md-12">
            <a :href="banner.link" class="-over" :target="target">
              <img
                :src="banner.image_url"
                class="img-fluid"
                alt=""
                @click="
                  trackGtmEvent(
                    eventList[index]['category'],
                    eventList[index]['action']
                  )
                "
              />
            </a>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import { trackGtmEvent } from "@/utils/Gtm";

import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default {
  name: "SwiperBanner",
  components: { Swiper, SwiperSlide },
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    target: {
      type: String,
      default: "_self",
    },
  },
  setup() {
    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      modules: [Pagination, Navigation],
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/stylesheets/styles";

.swiper-banner {
  position: relative;

  :deep(.swiper) {
    max-width: 1100px;

    .swiper-pagination {
      position: relative;
      margin: 20px 0 -8.5px;

      @include mq-down(md) {
        margin: 15px 0 -1px;
      }

      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;

        &-active {
          background-color: $primary;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    background-size: 20px 33px;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: -45px;

    @include mq-down(md) {
      display: none;
    }

    &::after {
      content: none;
    }
  }

  .swiper-button-prev {
    background-image: url("@/assets/images/icons/arrow-left-swiper.svg");
    left: 0;
  }

  .swiper-button-next {
    background-image: url("@/assets/images/icons/arrow-right-swiper.svg");
    right: 0;
  }

  .-over {
    &:hover {
      opacity: 0.75;
    }
  }
}
</style>
